import TableSegmentQuantityReport from './TableSegmentQuantityReport';

export default TableSegmentQuantityReport;
export { TableSegmentQuantityReport };
